/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiRateLimitEndpoint } from './InternalApiRateLimitEndpoint';
import {
    InternalApiRateLimitEndpointFromJSON,
    InternalApiRateLimitEndpointFromJSONTyped,
    InternalApiRateLimitEndpointToJSON,
    InternalApiRateLimitEndpointToJSONTyped,
} from './InternalApiRateLimitEndpoint';
import type { InternalApiRateLimitBucket } from './InternalApiRateLimitBucket';
import {
    InternalApiRateLimitBucketFromJSON,
    InternalApiRateLimitBucketFromJSONTyped,
    InternalApiRateLimitBucketToJSON,
    InternalApiRateLimitBucketToJSONTyped,
} from './InternalApiRateLimitBucket';

/**
 * 
 * @export
 * @interface InternalApiRateLimitConfiguration
 */
export interface InternalApiRateLimitConfiguration {
    /**
     * 
     * @type {Array<InternalApiRateLimitBucket>}
     * @memberof InternalApiRateLimitConfiguration
     */
    buckets: Array<InternalApiRateLimitBucket>;
    /**
     * 
     * @type {Array<InternalApiRateLimitEndpoint>}
     * @memberof InternalApiRateLimitConfiguration
     */
    availableEndpoints: Array<InternalApiRateLimitEndpoint>;
    /**
     * 
     * @type {number}
     * @memberof InternalApiRateLimitConfiguration
     */
    remainingLimitPerSecond: number;
}

/**
 * Check if a given object implements the InternalApiRateLimitConfiguration interface.
 */
export function instanceOfInternalApiRateLimitConfiguration(value: object): value is InternalApiRateLimitConfiguration {
    if (!('buckets' in value) || value['buckets'] === undefined) return false;
    if (!('availableEndpoints' in value) || value['availableEndpoints'] === undefined) return false;
    if (!('remainingLimitPerSecond' in value) || value['remainingLimitPerSecond'] === undefined) return false;
    return true;
}

export function InternalApiRateLimitConfigurationFromJSON(json: any): InternalApiRateLimitConfiguration {
    return InternalApiRateLimitConfigurationFromJSONTyped(json, false);
}

export function InternalApiRateLimitConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRateLimitConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'buckets': ((json['buckets'] as Array<any>).map(InternalApiRateLimitBucketFromJSON)),
        'availableEndpoints': ((json['availableEndpoints'] as Array<any>).map(InternalApiRateLimitEndpointFromJSON)),
        'remainingLimitPerSecond': json['remainingLimitPerSecond'],
    };
}

export function InternalApiRateLimitConfigurationToJSON(json: any): InternalApiRateLimitConfiguration {
    return InternalApiRateLimitConfigurationToJSONTyped(json, false);
}

export function InternalApiRateLimitConfigurationToJSONTyped(value?: InternalApiRateLimitConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'buckets': ((value['buckets'] as Array<any>).map(InternalApiRateLimitBucketToJSON)),
        'availableEndpoints': ((value['availableEndpoints'] as Array<any>).map(InternalApiRateLimitEndpointToJSON)),
        'remainingLimitPerSecond': value['remainingLimitPerSecond'],
    };
}

